import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErpSyncEvidencePage } from '@pages/erp-sync-evidence';

export const Route = createFileRoute('/$locale/_authenticated/erp-sync/evidence')({
  validateSearch: z.object({
    focus: z.string().optional(),
    page: z.coerce.number().int().positive().optional(),
    query: z.string().trim().max(200).optional(),
    contract: z.string().trim().min(1).max(200).optional(),
    operation: z.enum(['migration', 'sync']).optional(),
    trigger: z.enum(['manual', 'schedule']).optional(),
    startedFrom: z.iso.datetime({ offset: true }).optional(),
    startedTo: z.iso.datetime({ offset: true }).optional(),
    status: z
      .enum(['queued', 'running', 'succeeded', 'partial', 'failed', 'cancelled', 'blocked'])
      .optional(),
    validationStatus: z.enum(['passed', 'warning', 'blocked', 'pending']).optional(),
  }),
  component: ErpSyncEvidenceRoute,
});

function ErpSyncEvidenceRoute() {
  const { locale } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ErpSyncEvidencePage
      initialFocusKey={search.focus}
      initialPage={search.page ?? 1}
      initialQuery={search.query ?? ''}
      initialContractKey={search.contract}
      initialOperation={search.operation ?? '__all__'}
      initialTrigger={search.trigger ?? '__all__'}
      initialStartedFrom={search.startedFrom}
      initialStartedTo={search.startedTo}
      initialStatus={search.status ?? '__all__'}
      initialValidationStatus={search.validationStatus ?? '__all__'}
      onOpenBatches={() => {
        void navigate({ to: '/$locale/erp-sync/migration-batches', params: { locale } });
      }}
      onOpenDataQuality={() => {
        void navigate({ to: '/$locale/erp-sync/data-quality', params: { locale } });
      }}
      onOpenFailures={() => {
        void navigate({ to: '/$locale/erp-sync/failures', params: { locale } });
      }}
      onViewStateChange={(next) => {
        void navigate({
          replace: true,
          search: {
            focus: next.focus,
            page: next.page === 1 ? undefined : next.page,
            query: next.query,
            contract: search.contract,
            operation: next.operation,
            trigger: next.trigger,
            startedFrom: next.startedFrom,
            startedTo: next.startedTo,
            status: next.status,
            validationStatus: next.validationStatus,
          },
        });
      }}
    />
  );
}
